import { Slider } from '@mui/material';
import { useRef } from 'react';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import useUIState from 'src/state/ui/persistUiState';

export const EffectsBlurEdit = () => {
  const { filterParams, setFilterParams } = useLivekitRTCState();
  const { setFilterParams: setFilterParamsUIState } = useUIState();

  const initialValue = useRef(filterParams.blurRadius);

  const handleChangeBlur = (event: Event, value: number | number[]) => {
    const params = {
      blurRadius: value as number,
    };
    setFilterParams('blur', params);
    setFilterParamsUIState(params);
  };

  return (
    <Slider
      defaultValue={initialValue.current}
      step={10}
      min={5}
      max={25}
      marks
      onChange={handleChangeBlur}
      sx={{ width: 100 }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    />
  );
};
